import { Graphics } from 'pixi.js';
import { selectionBox } from '../../state/selection';
import { worldToScreen } from '../Camera';
import { COLORS } from '../constants';

// ============================================================================
// SelectionLayer - Renders selection box and UI overlays
// ============================================================================

let worldGraphics: Graphics; // For world-space selection highlights
let uiGraphics: Graphics; // For screen-space selection box

export const createSelectionLayer = (): { worldGraphics: Graphics; uiGraphics: Graphics } => {
  worldGraphics = new Graphics();
  uiGraphics = new Graphics();
  return { worldGraphics, uiGraphics };
};

export const drawSelectionHighlights = (): void => {
  worldGraphics.clear();
  // Selection highlights now handled in PawnLayer with rectangular outline
};

export const drawSelectionBox = (): void => {
  uiGraphics.clear();

  const box = selectionBox.value;
  if (!box) {
    return;
  }

  // IMPORTANT: worldToScreen uses a preallocated object, so we must copy values immediately
  const startResult = worldToScreen({ worldX: box.startX, worldY: box.startY });
  const startX = startResult.x;
  const startY = startResult.y;

  const endResult = worldToScreen({ worldX: box.endX, worldY: box.endY });
  const endX = endResult.x;
  const endY = endResult.y;

  const x = Math.min(startX, endX);
  const y = Math.min(startY, endY);
  const width = Math.abs(endX - startX);
  const height = Math.abs(endY - startY);

  // Fill
  uiGraphics.setFillStyle({ color: COLORS.SELECTION_FILL, alpha: COLORS.SELECTION_ALPHA });
  uiGraphics.rect(x, y, width, height);
  uiGraphics.fill();

  // Stroke
  uiGraphics.setStrokeStyle({ width: 1, color: COLORS.SELECTION_STROKE, alpha: 0.8 });
  uiGraphics.rect(x, y, width, height);
  uiGraphics.stroke();
};
